import Page from '@averyano/core/src/classes/Page';

export default class PolicyPage extends Page {
	constructor(el, id) {
		super({
			element: el,
		});
		this.id = id;
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();
	}

	onResize() {}
}
